export default __webpack_public_path__ + "static/media/tech_camp_at_locationBG.ca629dfc.jpg";